/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EnrollmentCallOutcome {
  CANCELED = 'CANCELED',
  NO_SHOW = 'NO_SHOW',
  ELECTED_PLAN = 'ELECTED_PLAN',
  UNDECIDED = 'UNDECIDED',
}
